import { useEffect, useRef } from "react";

import { NATIVE_SSO_RESULT_EVENT } from "@/lib/utils/native-sso";

import type { NativeSSOResult } from "@/lib/utils/native-sso";

/**
 * Subscribes to the window event the native app wrappers dispatch after
 * completing an in-app popup SSO flow (Custom Tabs / ASWebAuthenticationSession).
 */
export function useNativeSSOResult(
	onResult: (result: NativeSSOResult) => void,
): void {
	const onResultRef = useRef(onResult);

	useEffect(() => {
		onResultRef.current = onResult;
	}, [onResult]);

	useEffect(() => {
		const listener = (event: Event): void => {
			const detail = (event as CustomEvent<Partial<NativeSSOResult>>).detail;
			if (
				detail?.token &&
				(detail.provider === "google" || detail.provider === "microsoft")
			) {
				onResultRef.current({ provider: detail.provider, token: detail.token });
			}
		};

		window.addEventListener(NATIVE_SSO_RESULT_EVENT, listener);

		return () => window.removeEventListener(NATIVE_SSO_RESULT_EVENT, listener);
	}, []);
}
